import { createContext, useContext } from "react";

export const AppConfigContext = createContext(null);

export function useAppConfigContext() {
  return useContext(AppConfigContext);
}
